import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as facets from '../actions/facets';
import { applyOver, createUXFacetGroups, prepFacetGroups, prepFacets } from '../../facets/helpers/facets';
import { hasProps } from '../../core/helpers/object';
var initialState = {
    initGroups: false,
    initFacets: false,
    loading: false,
    groups: {},
    currentGroups: [],
    facets: {},
    facetCounts: {},
    applied: {}
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case facets.INIT_GROUPS:
            return tslib_1.__assign({}, state, { initGroups: true });
        case facets.INIT_GROUPS_SUCCESS:
            var preppedGroups = prepFacetGroups(action.payload);
            return tslib_1.__assign({}, state, { groups: preppedGroups, initGroups: false });
        case facets.INIT_GROUPS_FAILED:
            return tslib_1.__assign({}, state, { initGroups: false });
        case facets.INIT_FACETS:
            return tslib_1.__assign({}, state, { initFacets: true });
        case facets.INIT_FACETS_SUCCESS:
            var preppedFacets = prepFacets(action.payload);
            return tslib_1.__assign({}, state, { facets: preppedFacets, initFacets: false });
        case facets.INIT_FACETS_FAILED:
            return tslib_1.__assign({}, state, { initFacets: false });
        case facets.LOAD:
            return tslib_1.__assign({}, state, { loading: true });
        case facets.LOAD_SUCCESS:
            var facetCount = applyOver(action.payload);
            return tslib_1.__assign({}, state, { loading: false, facetCounts: facetCount, currentGroups: Object.keys(facetCount) });
        case facets.LOAD_FAILED:
            return tslib_1.__assign({}, state, { loading: false });
        case facets.APPLY:
            return tslib_1.__assign({}, state, { applied: action.payload });
        default:
            return state;
    }
}
// Public Selectors
export var isInitializing = function (state) { return state.initGroups || state.initFacets; };
export var isLoading = function (state) { return state.loading; };
export var getFacets = function (state) { return state.facets; };
export var getGroups = function (state) { return state.groups; };
export var getCounts = function (state) { return state.facetCounts; };
export var getCurrentGroups = function (state) { return state.currentGroups; };
export var getAppliedFacets = function (state) { return state.applied; };
// Complex public selectors
export var hasApplied = createSelector(getAppliedFacets, function (applied) { return applied && hasProps(applied); });
export var hasGroups = createSelector(getGroups, function (groups) { return groups && hasProps(groups); });
export var hasFacets = createSelector(getFacets, function (facets) { return facets && hasProps(facets); });
export var getFacetsUX = createSelector(getCurrentGroups, getGroups, getFacets, getCounts, createUXFacetGroups);
